import React from "react";
import HeaderButton from "./HeaderButton";
import { NavLink } from "react-router-dom";

const HeaderOriginal = () => {
  return (
    <header
      className="bg-center bg-no-repeat bg-[50%_auto] pt-2 px-4 h-24 max-w-screen-2xl mx-auto"
      style={{ backgroundImage: "url('/images/header_background.png')" }}
    >

    <div className="flex flex-row-reverse justify-between items-center">
      <NavLink to="/" className={'overflow-hidden'}>  
        <img
          className="w-[7rem] scale-[1.4]"
          src="/images/header_original_logo.jpg"
          alt="logo"
        />
      </NavLink>
      <div className="gap-x-2 flex">
        <HeaderButton
          dropdownItems={[
            {
              label: "تسجيل حساب جديد",
              href: "#",
              icon: "",
            },
            {
              label: "لا يوجد تبرعات مضافة في السلة",
              href: "#",
              icon: "",
            },
          ]}
        ></HeaderButton>
      </div>
    </div>
    </header>
  );
};

export default HeaderOriginal;
